/**
 * Shared "load more" handler.
 *
 * Replaces three near-identical inline scripts that lived in:
 *   - resources/views/pages/blog/index.blade.php
 *   - resources/views/partials/catalogs/catalogs_of_a_store.blade.php
 *   - resources/views/pages/branch/catalog.blade.php
 *
 * Configuration comes from data-* attributes on the trigger button:
 *   data-endpoint          — URL (built in Blade via locale_route())
 *   data-offset            — starting offset (numeric)
 *   data-offset-increment  — how many items to request per click (default 8)
 *   data-container         — CSS selector of the element that receives appended HTML
 *
 * Server contract (same across all three endpoints):
 *   Request:  GET ?offset=N
 *   Response: JSON { html: string, hasMore: boolean }
 *
 * Phase 55.9 — why there is no CSRF token here.
 * Adapted from dealzbookae Phase 56.7 (shipped 2026-07-16).
 *
 * These endpoints are reads (offset -> SELECT -> render partial -> JSON). They were POSTs, which
 * is the only reason they needed a token at all — and these pages are served cookie-free (Phase
 * 35.13), so no token rendered into one can ever be valid: it is either Spatie's frozen
 * `<laravel-responsecache-csrf-token-here>` placeholder on a cache HIT, or a real token bound to
 * a session whose cookie was stripped on the way out. Either way it cannot match.
 *
 * The button worked anyway only because Laravel skips the token check entirely when the browser
 * sends `Sec-Fetch-Site: same-origin` — so anything that omits that header got a 419. As GETs,
 * `isReading()` short-circuits the CSRF middleware before any of that applies.
 */

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.load-more-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var offset    = parseInt(btn.dataset.offset, 10) || 0;
            var increment = parseInt(btn.dataset.offsetIncrement, 10) || 8;
            var endpoint  = btn.dataset.endpoint;
            var container = document.querySelector(btn.dataset.container);

            if (!endpoint || !container) return;

            btn.disabled = true;

            var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'offset=' + offset;

            fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (response) {
                    // Surface a failed request instead of dying inside json(): an error response is
                    // HTML, so json() throws a parse error that says nothing about the real cause —
                    // which is why the 419s went unnoticed.
                    if (!response.ok) {
                        throw new Error('load-more returned HTTP ' + response.status);
                    }
                    return response.json();
                })
                .then(function (data) {
                    if (data.html) {
                        container.insertAdjacentHTML('beforeend', data.html);
                        btn.dataset.offset = offset + increment;
                    }

                    if (!data.hasMore) {
                        btn.style.display = 'none';
                    } else {
                        btn.disabled = false;
                    }
                })
                .catch(function (error) {
                    console.error('load-more failed:', error);
                    btn.disabled = false;
                });
        });
    });
});
